import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getGeofencesFn = () => restHelpers.withBearer.get(`${K.API_URL}/geofences?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}`, {});
const getGeofenceAvailableVehiclesFn = () => restHelpers.withBearer.get(`${K.API_URL}/cars/get-all?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}`, {});
const getGeofenceVehiclesFn = (geofenceId) => restHelpers.withBearer.get(`${K.API_URL}/geofences/${geofenceId}/vehicles?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}`, {});
const getGeofenceFn = (geofenceId) => restHelpers.withBearer.get(`${K.API_URL}/geofences/${geofenceId}?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}`, {});
const createGeofenceFn = (geofence) => restHelpers.withBearer.post(`${K.API_URL}/geofences`, { data: geofence });
const updateGeofenceFn = (geofenceId, geofence) => restHelpers.withBearer.put(`${K.API_URL}/geofences/${geofenceId}`, { data: geofence });
const deleteGeofenceFn = geofenceId => restHelpers.withBearer.delete(`${K.API_URL}/geofences/${geofenceId}`, { });

export default {
    getGeofences: getGeofencesFn,
    getGeofence: getGeofenceFn,
    getGeofenceVehicles: getGeofenceVehiclesFn,
    getGeofenceAvailableVehicles: getGeofenceAvailableVehiclesFn,
    createGeofence: createGeofenceFn,
    updateGeofence: updateGeofenceFn,
    deleteGeofence: deleteGeofenceFn
}


// WEBPACK FOOTER //
// ./src/services/geofences.js